import { post } from '../actions/ajax';
import loginActions from '../actions/loginActionCreators';
import store from '../reducers/storeRegistration';
const isUnauthorized = error => {
  var _error$response;
  return (error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401;
};

/**
 * POSTs to an authenticated endpoint and, when the access token has gone stale (401), refreshes
 * it once and retries. Any other failure - and a failed retry - is rethrown so the caller can
 * decide whether to surface it to the user or log it.
 */
const postWithTokenRefresh = async (url, payload) => {
  try {
    return await post(url, payload);
  } catch (error) {
    if (!isUnauthorized(error)) {
      throw error;
    }
    await store.dispatch(loginActions.serverToken());
    return post(url, payload);
  }
};
export default postWithTokenRefresh;